import styled from "styled-components";

export const StyledLink = styled.a`
  box-shadow: 2px 11px 32px rgba(0, 0, 0, 0.4);
  background-color: #ffdf77;
  text-decoration: none;
  border-radius: 25px;
  line-height: 55px;
  font-family: Yrsa;
  font-weight: 500;
  font-size: 22px;
  color: #25242a;
  height: 50px;
  width: 210px;
  z-index: 100;
`;
